import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";
import { localServiceData } from "@/data/localServiceData";

const ThuisbatterijWestervoort = () => {
  return <LocalServiceTemplate data={localServiceData['thuisbatterij-westervoort']} />;
};

export default ThuisbatterijWestervoort;